__turbopack_context__.v({
  "card-content": "_67xCEa_card-content",
  "container": "_67xCEa_container",
  "el-product": "_67xCEa_el-product",
  "fixed-product-price": "_67xCEa_fixed-product-price",
  "gas-product": "_67xCEa_gas-product",
  "location": "_67xCEa_location",
  "over-capacity": "_67xCEa_over-capacity",
  "personal-instalment": "_67xCEa_personal-instalment",
  "price": "_67xCEa_price",
  "price-explanation": "_67xCEa_price-explanation",
  "producer": "_67xCEa_producer",
  "promo": "_67xCEa_promo",
  "promo-line": "_67xCEa_promo-line",
  "secondary": "_67xCEa_secondary",
  "section": "_67xCEa_section",
  "section-header": "_67xCEa_section-header",
  "section-title": "_67xCEa_section-title",
  "selected-producer": "_67xCEa_selected-producer",
  "simulation": "_67xCEa_simulation",
  "simulation-actions": "_67xCEa_simulation-actions",
  "tooltip-icon": "_67xCEa_tooltip-icon",
  "usage": "_67xCEa_usage",
  "usage-badges": "_67xCEa_usage-badges",
});
